const repeatsMultiSelectOptions = [
    {
        label: "Monomer",
        options:[
            {label: "A", value: "A"},
            {label: "C", value: "C"}
        ]
    },
    {
        label: "Dimer",
        options: [
            {label: "AC", value: "AC"},
            {label: "AG", value: "AG"},
            {label: "AT", value: "AT"},
            {label: "CG", value: "CG"}
        ]
    },
    {
        label: "Trimer",
        options: [
            {label: "AAC", value: "AAC"},
            {label: "AAG", value: "AAG"},
            {label: "AAT", value: "AAT"},
            {label: "ACC", value: "ACC"},
            {label: "ACG", value: "ACG"},
            {label: "ACT", value: "ACT"},
            {label: "AGC", value: "AGC"},
            {label: "AGG", value: "AGG"},
            {label: "ATC", value: "ATC"},
            {label: "CCG", value: "CCG"}
        ]
    },
    {
        label: "Tetramer",
        options: [
            {label: "AAAC", value: "AAAC"},
            {label: "AAAG", value: "AAAG"},
            {label: "AAAT", value: "AAAT"},
            {label: "AACC", value: "AACC"},
            {label: "AACG", value: "AACG"},
            {label: "AACT", value: "AACT"},
            {label: "AAGC", value: "AAGC"},
            {label: "AAGG", value: "AAGG"},
            {label: "AAGT", value: "AAGT"},
            {label: "AATC", value: "AATC"},
            {label: "AATG", value: "AATG"},
            {label: "AATT", value: "AATT"},
            {label: "ACAG", value: "ACAG"},
            {label: "ACAT", value: "ACAT"},
            {label: "ACCC", value: "ACCC"},
            {label: "ACCG", value: "ACCG"},
            {label: "ACCT", value: "ACCT"},
            {label: "ACGC", value: "ACGC"},
            {label: "ACGG", value: "ACGG"},
            {label: "ACGT", value: "ACGT"},
            {label: "ACTC", value: "ACTC"},
            {label: "ACTG", value: "ACTG"},
            {label: "AGAT", value: "AGAT"},
            {label: "AGCC", value: "AGCC"},
            {label: "AGCG", value: "AGCG"},
            {label: "AGCT", value: "AGCT"},
            {label: "AGGC", value: "AGGC"},
            {label: "AGGG", value: "AGGG"},
            {label: "ATCC", value: "ATCC"},
            {label: "ATCG", value: "ATCG"},
            {label: "ATGC", value: "ATGC"},
            {label: "CCCG", value: "CCCG"},
            {label: "CCGG", value: "CCGG"}
        ]
    },
    {
        label: "Pentamer",
        options: [
            {label: "AAAAC", value: "AAAAC"},
            {label: "AAAAG", value: "AAAAG"},
            {label: "AAAAT", value: "AAAAT"},
            {label: "AAACC", value: "AAACC"},
            {label: "AAACG", value: "AAACG"},
            {label: "AAACT", value: "AAACT"},
            {label: "AAAGC", value: "AAAGC"},
            {label: "AAAGG", value: "AAAGG"},
            {label: "AAAGT", value: "AAAGT"},
            {label: "AAATC", value: "AAATC"},
            {label: "AAATG", value: "AAATG"},
            {label: "AAATT", value: "AAATT"},
            {label: "AACAC", value: "AACAC"},
            {label: "AACAG", value: "AACAG"},
            {label: "AACAT", value: "AACAT"},
            {label: "AACCC", value: "AACCC"},
            {label: "AACCG", value: "AACCG"},
            {label: "AACCT", value: "AACCT"},
            {label: "AACGC", value: "AACGC"},
            {label: "AACGG", value: "AACGG"},
            {label: "AACGT", value: "AACGT"},
            {label: "AACTC", value: "AACTC"},
            {label: "AACTG", value: "AACTG"},
            {label: "AACTT", value: "AACTT"},
            {label: "AAGAC", value: "AAGAC"},
            {label: "AAGAG", value: "AAGAG"},
            {label: "AAGAT", value: "AAGAT"},
            {label: "AAGCC", value: "AAGCC"},
            {label: "AAGCG", value: "AAGCG"},
            {label: "AAGCT", value: "AAGCT"},
            {label: "AAGGC", value: "AAGGC"},
            {label: "AAGGG", value: "AAGGG"},
            {label: "AAGGT", value: "AAGGT"},
            {label: "AAGTC", value: "AAGTC"},
            {label: "AAGTG", value: "AAGTG"},
            {label: "AATAC", value: "AATAC"},
            {label: "AATAG", value: "AATAG"},
            {label: "AATAT", value: "AATAT"},
            {label: "AATCC", value: "AATCC"},
            {label: "AATCG", value: "AATCG"},
            {label: "AATCT", value: "AATCT"},
            {label: "AATGC", value: "AATGC"},
            {label: "AATGG", value: "AATGG"},
            {label: "AATGT", value: "AATGT"},
            {label: "AATTC", value: "AATTC"},
            {label: "ACACC", value: "ACACC"},
            {label: "ACACG", value: "ACACG"},
            {label: "ACACT", value: "ACACT"},
            {label: "ACAGC", value: "ACAGC"},
            {label: "ACAGG", value: "ACAGG"},
            {label: "ACAGT", value: "ACAGT"},
            {label: "ACATC", value: "ACATC"},
            {label: "ACATG", value: "ACATG"},
            {label: "ACCAG", value: "ACCAG"},
            {label: "ACCAT", value: "ACCAT"},
            {label: "ACCCC", value: "ACCCC"},
            {label: "ACCCG", value: "ACCCG"},
            {label: "ACCCT", value: "ACCCT"},
            {label: "ACCGC", value: "ACCGC"},
            {label: "ACCGG", value: "ACCGG"},
            {label: "ACCGT", value: "ACCGT"},
            {label: "ACCTC", value: "ACCTC"},
            {label: "ACCTG", value: "ACCTG"},
            {label: "ACGAG", value: "ACGAG"},
            {label: "ACGAT", value: "ACGAT"},
            {label: "ACGCC", value: "ACGCC"},
            {label: "ACGCG", value: "ACGCG"},
            {label: "ACGCT", value: "ACGCT"},
            {label: "ACGGC", value: "ACGGC"},
            {label: "ACGGG", value: "ACGGG"},
            {label: "ACGTC", value: "ACGTC"},
            {label: "ACTAG", value: "ACTAG"},
            {label: "ACTAT", value: "ACTAT"},
            {label: "ACTCC", value: "ACTCC"},
            {label: "ACTCG", value: "ACTCG"},
            {label: "ACTCT", value: "ACTCT"},
            {label: "ACTGC", value: "ACTGC"},
            {label: "ACTGG", value: "ACTGG"},
            {label: "AGAGC", value: "AGAGC"},
            {label: "AGAGG", value: "AGAGG"},
            {label: "AGATC", value: "AGATC"},
            {label: "AGATG", value: "AGATG"},
            {label: "AGCAT", value: "AGCAT"},
            {label: "AGCCC", value: "AGCCC"},
            {label: "AGCCG", value: "AGCCG"},
            {label: "AGCCT", value: "AGCCT"},
            {label: "AGCGC", value: "AGCGC"},
            {label: "AGCGG", value: "AGCGG"},
            {label: "AGCTC", value: "AGCTC"},
            {label: "AGGAT", value: "AGGAT"},
            {label: "AGGCC", value: "AGGCC"},
            {label: "AGGCG", value: "AGGCG"},
            {label: "AGGGC", value: "AGGGC"},
            {label: "AGGGG", value: "AGGGG"},
            {label: "ATATC", value: "ATATC"},
            {label: "ATCCC", value: "ATCCC"},
            {label: "ATCCG", value: "ATCCG"},
            {label: "ATCGC", value: "ATCGC"},
            {label: "ATGCC", value: "ATGCC"},
            {label: "CCCCG", value: "CCCCG"},
            {label: "CCCGG", value: "CCCGG"},
            {label: "CCGCG", value: "CCGCG"}
        ]
    },
    {
        label: "Hexamer",
        options: [
            {label: "AAAAAC", value: "AAAAAC"},
            {label: "AAAAAG", value: "AAAAAG"},
            {label: "AAAAAT", value: "AAAAAT"},
            {label: "AAAACC", value: "AAAACC"},
            {label: "AAAACG", value: "AAAACG"},
            {label: "AAAACT", value: "AAAACT"},
            {label: "AAAAGC", value: "AAAAGC"},
            {label: "AAAAGG", value: "AAAAGG"},
            {label: "AAAAGT", value: "AAAAGT"},
            {label: "AAAATC", value: "AAAATC"},
            {label: "AAAATG", value: "AAAATG"},
            {label: "AAAATT", value: "AAAATT"},
            {label: "AAACAC", value: "AAACAC"},
            {label: "AAACAG", value: "AAACAG"},
            {label: "AAACAT", value: "AAACAT"},
            {label: "AAACCC", value: "AAACCC"},
            {label: "AAACCG", value: "AAACCG"},
            {label: "AAACCT", value: "AAACCT"},
            {label: "AAACGC", value: "AAACGC"},
            {label: "AAACGG", value: "AAACGG"},
            {label: "AAACGT", value: "AAACGT"},
            {label: "AAACTC", value: "AAACTC"},
            {label: "AAACTG", value: "AAACTG"},
            {label: "AAACTT", value: "AAACTT"},
            {label: "AAAGAC", value: "AAAGAC"},
            {label: "AAAGAG", value: "AAAGAG"},
            {label: "AAAGAT", value: "AAAGAT"},
            {label: "AAAGCC", value: "AAAGCC"},
            {label: "AAAGCG", value: "AAAGCG"},
            {label: "AAAGCT", value: "AAAGCT"},
            {label: "AAAGGC", value: "AAAGGC"},
            {label: "AAAGGG", value: "AAAGGG"},
            {label: "AAAGGT", value: "AAAGGT"},
            {label: "AAAGTC", value: "AAAGTC"},
            {label: "AAAGTG", value: "AAAGTG"},
            {label: "AAAGTT", value: "AAAGTT"},
            {label: "AAATAC", value: "AAATAC"},
            {label: "AAATAG", value: "AAATAG"},
            {label: "AAATAT", value: "AAATAT"},
            {label: "AAATCC", value: "AAATCC"},
            {label: "AAATCG", value: "AAATCG"},
            {label: "AAATCT", value: "AAATCT"},
            {label: "AAATGC", value: "AAATGC"},
            {label: "AAATGG", value: "AAATGG"},
            {label: "AAATGT", value: "AAATGT"},
            {label: "AAATTC", value: "AAATTC"},
            {label: "AAATTG", value: "AAATTG"},
            {label: "AAATTT", value: "AAATTT"},
            {label: "AACAAG", value: "AACAAG"},
            {label: "AACAAT", value: "AACAAT"},
            {label: "AACACC", value: "AACACC"},
            {label: "AACACG", value: "AACACG"},
            {label: "AACACT", value: "AACACT"},
            {label: "AACAGC", value: "AACAGC"},
            {label: "AACAGG", value: "AACAGG"},
            {label: "AACAGT", value: "AACAGT"},
            {label: "AACATC", value: "AACATC"},
            {label: "AACATG", value: "AACATG"},
            {label: "AACATT", value: "AACATT"},
            {label: "AACCAC", value: "AACCAC"},
            {label: "AACCAG", value: "AACCAG"},
            {label: "AACCAT", value: "AACCAT"},
            {label: "AACCCC", value: "AACCCC"},
            {label: "AACCCG", value: "AACCCG"},
            {label: "AACCCT", value: "AACCCT"},
            {label: "AACCGC", value: "AACCGC"},
            {label: "AACCGG", value: "AACCGG"},
            {label: "AACCGT", value: "AACCGT"},
            {label: "AACCTC", value: "AACCTC"},
            {label: "AACCTG", value: "AACCTG"},
            {label: "AACCTT", value: "AACCTT"},
            {label: "AACGAC", value: "AACGAC"},
            {label: "AACGAG", value: "AACGAG"},
            {label: "AACGAT", value: "AACGAT"},
            {label: "AACGCC", value: "AACGCC"},
            {label: "AACGCG", value: "AACGCG"},
            {label: "AACGCT", value: "AACGCT"},
            {label: "AACGGC", value: "AACGGC"},
            {label: "AACGGG", value: "AACGGG"},
            {label: "AACGGT", value: "AACGGT"},
            {label: "AACGTC", value: "AACGTC"},
            {label: "AACGTG", value: "AACGTG"},
            {label: "AACGTT", value: "AACGTT"},
            {label: "AACTAC", value: "AACTAC"},
            {label: "AACTAG", value: "AACTAG"},
            {label: "AACTAT", value: "AACTAT"},
            {label: "AACTCC", value: "AACTCC"},
            {label: "AACTCG", value: "AACTCG"},
            {label: "AACTCT", value: "AACTCT"},
            {label: "AACTGC", value: "AACTGC"},
            {label: "AACTGG", value: "AACTGG"},
            {label: "AACTGT", value: "AACTGT"},
            {label: "AACTTC", value: "AACTTC"},
            {label: "AACTTG", value: "AACTTG"},
            {label: "AAGAAT", value: "AAGAAT"},
            {label: "AAGACC", value: "AAGACC"},
            {label: "AAGACG", value: "AAGACG"},
            {label: "AAGACT", value: "AAGACT"},
            {label: "AAGAGC", value: "AAGAGC"},
            {label: "AAGAGG", value: "AAGAGG"},
            {label: "AAGAGT", value: "AAGAGT"},
            {label: "AAGATC", value: "AAGATC"},
            {label: "AAGATG", value: "AAGATG"},
            {label: "AAGATT", value: "AAGATT"},
            {label: "AAGCAC", value: "AAGCAC"},
            {label: "AAGCAG", value: "AAGCAG"},
            {label: "AAGCAT", value: "AAGCAT"},
            {label: "AAGCCC", value: "AAGCCC"},
            {label: "AAGCCG", value: "AAGCCG"},
            {label: "AAGCCT", value: "AAGCCT"},
            {label: "AAGCGC", value: "AAGCGC"},
            {label: "AAGCGG", value: "AAGCGG"},
            {label: "AAGCGT", value: "AAGCGT"},
            {label: "AAGCTC", value: "AAGCTC"},
            {label: "AAGCTG", value: "AAGCTG"},
            {label: "AAGCTT", value: "AAGCTT"},
            {label: "AAGGAC", value: "AAGGAC"},
            {label: "AAGGAG", value: "AAGGAG"},
            {label: "AAGGAT", value: "AAGGAT"},
            {label: "AAGGCC", value: "AAGGCC"},
            {label: "AAGGCG", value: "AAGGCG"},
            {label: "AAGGCT", value: "AAGGCT"},
            {label: "AAGGGC", value: "AAGGGC"},
            {label: "AAGGGG", value: "AAGGGG"},
            {label: "AAGGGT", value: "AAGGGT"},
            {label: "AAGGTC", value: "AAGGTC"},
            {label: "AAGGTG", value: "AAGGTG"},
            {label: "AAGTAC", value: "AAGTAC"},
            {label: "AAGTAG", value: "AAGTAG"},
            {label: "AAGTAT", value: "AAGTAT"},
            {label: "AAGTCC", value: "AAGTCC"},
            {label: "AAGTCG", value: "AAGTCG"},
            {label: "AAGTCT", value: "AAGTCT"},
            {label: "AAGTGC", value: "AAGTGC"},
            {label: "AAGTGG", value: "AAGTGG"},
            {label: "AAGTGT", value: "AAGTGT"},
            {label: "AATACC", value: "AATACC"},
            {label: "AATACG", value: "AATACG"},
            {label: "AATACT", value: "AATACT"},
            {label: "AATAGC", value: "AATAGC"},
            {label: "AATAGG", value: "AATAGG"},
            {label: "AATAGT", value: "AATAGT"},
            {label: "AATATC", value: "AATATC"},
            {label: "AATATG", value: "AATATG"},
            {label: "AATATT", value: "AATATT"},
            {label: "AATCAC", value: "AATCAC"},
            {label: "AATCAG", value: "AATCAG"},
            {label: "AATCAT", value: "AATCAT"},
            {label: "AATCCC", value: "AATCCC"},
            {label: "AATCCG", value: "AATCCG"},
            {label: "AATCCT", value: "AATCCT"},
            {label: "AATCGC", value: "AATCGC"},
            {label: "AATCGG", value: "AATCGG"},
            {label: "AATCGT", value: "AATCGT"},
            {label: "AATCTC", value: "AATCTC"},
            {label: "AATCTG", value: "AATCTG"},
            {label: "AATGAC", value: "AATGAC"},
            {label: "AATGAG", value: "AATGAG"},
            {label: "AATGAT", value: "AATGAT"},
            {label: "AATGCC", value: "AATGCC"},
            {label: "AATGCG", value: "AATGCG"},
            {label: "AATGCT", value: "AATGCT"},
            {label: "AATGGC", value: "AATGGC"},
            {label: "AATGGG", value: "AATGGG"},
            {label: "AATGGT", value: "AATGGT"},
            {label: "AATGTC", value: "AATGTC"},
            {label: "AATGTG", value: "AATGTG"},
            {label: "AATTAC", value: "AATTAC"},
            {label: "AATTAG", value: "AATTAG"},
            {label: "AATTAT", value: "AATTAT"},
            {label: "AATTCC", value: "AATTCC"},
            {label: "AATTCG", value: "AATTCG"},
            {label: "AATTGC", value: "AATTGC"},
            {label: "ACACAG", value: "ACACAG"},
            {label: "ACACAT", value: "ACACAT"},
            {label: "ACACCC", value: "ACACCC"},
            {label: "ACACCG", value: "ACACCG"},
            {label: "ACACCT", value: "ACACCT"},
            {label: "ACACGC", value: "ACACGC"},
            {label: "ACACGG", value: "ACACGG"},
            {label: "ACACGT", value: "ACACGT"},
            {label: "ACACTC", value: "ACACTC"},
            {label: "ACACTG", value: "ACACTG"},
            {label: "ACAGAG", value: "ACAGAG"},
            {label: "ACAGAT", value: "ACAGAT"},
            {label: "ACAGCC", value: "ACAGCC"},
            {label: "ACAGCG", value: "ACAGCG"},
            {label: "ACAGCT", value: "ACAGCT"},
            {label: "ACAGGC", value: "ACAGGC"},
            {label: "ACAGGG", value: "ACAGGG"},
            {label: "ACAGGT", value: "ACAGGT"},
            {label: "ACAGTC", value: "ACAGTC"},
            {label: "ACAGTG", value: "ACAGTG"},
            {label: "ACATAG", value: "ACATAG"},
            {label: "ACATAT", value: "ACATAT"},
            {label: "ACATCC", value: "ACATCC"},
            {label: "ACATCG", value: "ACATCG"},
            {label: "ACATCT", value: "ACATCT"},
            {label: "ACATGC", value: "ACATGC"},
            {label: "ACATGG", value: "ACATGG"},
            {label: "ACATGT", value: "ACATGT"},
            {label: "ACCACG", value: "ACCACG"},
            {label: "ACCACT", value: "ACCACT"},
            {label: "ACCAGC", value: "ACCAGC"},
            {label: "ACCAGG", value: "ACCAGG"},
            {label: "ACCAGT", value: "ACCAGT"},
            {label: "ACCATC", value: "ACCATC"},
            {label: "ACCATG", value: "ACCATG"},
            {label: "ACCCAG", value: "ACCCAG"},
            {label: "ACCCAT", value: "ACCCAT"},
            {label: "ACCCCC", value: "ACCCCC"},
            {label: "ACCCCG", value: "ACCCCG"},
            {label: "ACCCCT", value: "ACCCCT"},
            {label: "ACCCGC", value: "ACCCGC"},
            {label: "ACCCGG", value: "ACCCGG"},
            {label: "ACCCGT", value: "ACCCGT"},
            {label: "ACCCTC", value: "ACCCTC"},
            {label: "ACCCTG", value: "ACCCTG"},
            {label: "ACCGAG", value: "ACCGAG"},
            {label: "ACCGAT", value: "ACCGAT"},
            {label: "ACCGCC", value: "ACCGCC"},
            {label: "ACCGCG", value: "ACCGCG"},
            {label: "ACCGCT", value: "ACCGCT"},
            {label: "ACCGGC", value: "ACCGGC"},
            {label: "ACCGGG", value: "ACCGGG"},
            {label: "ACCGGT", value: "ACCGGT"},
            {label: "ACCGTC", value: "ACCGTC"},
            {label: "ACCGTG", value: "ACCGTG"},
            {label: "ACCTAG", value: "ACCTAG"},
            {label: "ACCTAT", value: "ACCTAT"},
            {label: "ACCTCC", value: "ACCTCC"},
            {label: "ACCTCG", value: "ACCTCG"},
            {label: "ACCTCT", value: "ACCTCT"},
            {label: "ACCTGC", value: "ACCTGC"},
            {label: "ACCTGG", value: "ACCTGG"},
            {label: "ACGACT", value: "ACGACT"},
            {label: "ACGAGC", value: "ACGAGC"},
            {label: "ACGAGG", value: "ACGAGG"},
            {label: "ACGAGT", value: "ACGAGT"},
            {label: "ACGATC", value: "ACGATC"},
            {label: "ACGATG", value: "ACGATG"},
            {label: "ACGCAG", value: "ACGCAG"},
            {label: "ACGCAT", value: "ACGCAT"},
            {label: "ACGCCC", value: "ACGCCC"},
            {label: "ACGCCG", value: "ACGCCG"},
            {label: "ACGCCT", value: "ACGCCT"},
            {label: "ACGCGC", value: "ACGCGC"},
            {label: "ACGCGG", value: "ACGCGG"},
            {label: "ACGCGT", value: "ACGCGT"},
            {label: "ACGCTC", value: "ACGCTC"},
            {label: "ACGCTG", value: "ACGCTG"},
            {label: "ACGGAG", value: "ACGGAG"},
            {label: "ACGGAT", value: "ACGGAT"},
            {label: "ACGGCC", value: "ACGGCC"},
            {label: "ACGGCG", value: "ACGGCG"},
            {label: "ACGGCT", value: "ACGGCT"},
            {label: "ACGGGC", value: "ACGGGC"},
            {label: "ACGGGG", value: "ACGGGG"},
            {label: "ACGTAG", value: "ACGTAG"},
            {label: "ACGTAT", value: "ACGTAT"},
            {label: "ACGTCC", value: "ACGTCC"},
            {label: "ACGTCG", value: "ACGTCG"},
            {label: "ACGTGC", value: "ACGTGC"},
            {label: "ACTAGC", value: "ACTAGC"},
            {label: "ACTAGG", value: "ACTAGG"},
            {label: "ACTAGT", value: "ACTAGT"},
            {label: "ACTATC", value: "ACTATC"},
            {label: "ACTATG", value: "ACTATG"},
            {label: "ACTCAG", value: "ACTCAG"},
            {label: "ACTCAT", value: "ACTCAT"},
            {label: "ACTCCC", value: "ACTCCC"},
            {label: "ACTCCG", value: "ACTCCG"},
            {label: "ACTCCT", value: "ACTCCT"},
            {label: "ACTCGC", value: "ACTCGC"},
            {label: "ACTCGG", value: "ACTCGG"},
            {label: "ACTCTC", value: "ACTCTC"},
            {label: "ACTCTG", value: "ACTCTG"},
            {label: "ACTGAG", value: "ACTGAG"},
            {label: "ACTGAT", value: "ACTGAT"},
            {label: "ACTGCC", value: "ACTGCC"},
            {label: "ACTGCG", value: "ACTGCG"},
            {label: "ACTGCT", value: "ACTGCT"},
            {label: "ACTGGC", value: "ACTGGC"},
            {label: "ACTGGG", value: "ACTGGG"},
            {label: "AGAGAT", value: "AGAGAT"},
            {label: "AGAGCC", value: "AGAGCC"},
            {label: "AGAGCG", value: "AGAGCG"},
            {label: "AGAGCT", value: "AGAGCT"},
            {label: "AGAGGC", value: "AGAGGC"},
            {label: "AGAGGG", value: "AGAGGG"},
            {label: "AGATAT", value: "AGATAT"},
            {label: "AGATCC", value: "AGATCC"},
            {label: "AGATCG", value: "AGATCG"},
            {label: "AGATCT", value: "AGATCT"},
            {label: "AGATGC", value: "AGATGC"},
            {label: "AGATGG", value: "AGATGG"},
            {label: "AGCAGG", value: "AGCAGG"},
            {label: "AGCATC", value: "AGCATC"},
            {label: "AGCATG", value: "AGCATG"},
            {label: "AGCCAT", value: "AGCCAT"},
            {label: "AGCCCC", value: "AGCCCC"},
            {label: "AGCCCG", value: "AGCCCG"},
            {label: "AGCCCT", value: "AGCCCT"},
            {label: "AGCCGC", value: "AGCCGC"},
            {label: "AGCCGG", value: "AGCCGG"},
            {label: "AGCCTC", value: "AGCCTC"},
            {label: "AGCCTG", value: "AGCCTG"},
            {label: "AGCGAT", value: "AGCGAT"},
            {label: "AGCGCC", value: "AGCGCC"},
            {label: "AGCGCG", value: "AGCGCG"},
            {label: "AGCGCT", value: "AGCGCT"},
            {label: "AGCGGC", value: "AGCGGC"},
            {label: "AGCGGG", value: "AGCGGG"},
            {label: "AGCTAT", value: "AGCTAT"},
            {label: "AGCTCC", value: "AGCTCC"},
            {label: "AGCTCG", value: "AGCTCG"},
            {label: "AGCTGC", value: "AGCTGC"},
            {label: "AGGATC", value: "AGGATC"},
            {label: "AGGATG", value: "AGGATG"},
            {label: "AGGCAT", value: "AGGCAT"},
            {label: "AGGCCC", value: "AGGCCC"},
            {label: "AGGCCG", value: "AGGCCG"},
            {label: "AGGCCT", value: "AGGCCT"},
            {label: "AGGCGC", value: "AGGCGC"},
            {label: "AGGCGG", value: "AGGCGG"},
            {label: "AGGGAT", value: "AGGGAT"},
            {label: "AGGGCC", value: "AGGGCC"},
            {label: "AGGGCG", value: "AGGGCG"},
            {label: "AGGGGC", value: "AGGGGC"},
            {label: "AGGGGG", value: "AGGGGG"},
            {label: "ATATCC", value: "ATATCC"},
            {label: "ATATCG", value: "ATATCG"},
            {label: "ATATGC", value: "ATATGC"},
            {label: "ATCATG", value: "ATCATG"},
            {label: "ATCCCC", value: "ATCCCC"},
            {label: "ATCCCG", value: "ATCCCG"},
            {label: "ATCCGC", value: "ATCCGC"},
            {label: "ATCCGG", value: "ATCCGG"},
            {label: "ATCGCC", value: "ATCGCC"},
            {label: "ATCGCG", value: "ATCGCG"},
            {label: "ATCGGC", value: "ATCGGC"},
            {label: "ATGCCC", value: "ATGCCC"},
            {label: "ATGCGC", value: "ATGCGC"},
            {label: "ATGGCC", value: "ATGGCC"},
            {label: "CCCCCG", value: "CCCCCG"},
            {label: "CCCCGG", value: "CCCCGG"},
            {label: "CCCGCG", value: "CCCGCG"},
            {label: "CCCGGG", value: "CCCGGG"},
            {label: "CCGCGG", value: "CCGCGG"},
            {label: "CCGGCG", value: "CCGGCG"}
        ]
    }
]

export { repeatsMultiSelectOptions }